import { render } from "./xaizai.vue?vue&type=template&id=29b91d6a"
import script from "./xaizai.vue?vue&type=script&lang=js"
export * from "./xaizai.vue?vue&type=script&lang=js"

import "./xaizai.vue?vue&type=style&index=0&id=29b91d6a&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__